export default function mapFieldsToState(fields, query = {}, countryCode) {
  if (!fields || !fields.length) return {};

  const fieldsFormFields = fields.reduce((obj, item) => {
    const defaultValue = item.defaultValue?.enabled ? item.defaultValue.value : '';

    if (item.element === 'country') {
      obj[item._id] = {
        ...item,
        value: defaultValue || countryCode || 'US',
      };
      return obj;
    }

    if (item.element === 'checkbox') {
      if (defaultValue === 'true') {
        obj[item._id] = { ...item, value: true };
      } else if (defaultValue === 'false') {
        obj[item._id] = { ...item, value: false };
      } else {
        obj[item._id] = { ...item, value: defaultValue || false };
      }
      return obj;
    }

    if (item.element === 'quantity') {
      obj[item._id] = { ...item, value: Number(defaultValue) || 1 };
      return obj;
    }

    obj[item._id] = { ...item, value: defaultValue };
    return obj;
  }, {});

  // match params to form field references
  Object.entries(query).forEach(([key, value]) => {
    const field = Object.values(fieldsFormFields).find(field => field.reference === key);

    if (field) {
      // For phone fields, properly decode the URL component
      if (field.element === 'phone') {
        fieldsFormFields[field._id].value = decodeURIComponent(value.replace(/\s/g, '+'));
      } else {
        fieldsFormFields[field._id].value = value;
      }
    }
  });

  return fieldsFormFields;
}
